import { useCallback } from 'react';
import { checkSkuAndItemName } from '../utils/common';

export interface IUseNameSkuUniquenessCheckProps {
  fieldPrefix: string;
  formMethods: any;
  data?: any;
}

export const useNameSkuUniquenessCheck = ({
  fieldPrefix,
  formMethods,
  data,
}: IUseNameSkuUniquenessCheckProps) => {
  const { watch=()=>{}, setError=()=>{} } = formMethods||{};
  const formValues = watch(fieldPrefix);

  const namePrev = data?.name;
  const skuPrev= data?.sku
  const checkNameAndSkuUniqueness = useCallback(async () => {
 let isUnique=true;  

    try {
      if(namePrev===formValues?.name && skuPrev===formValues?.sku) return true;
      const response = await checkSkuAndItemName({
        name: formValues?.name,
        sku: formValues?.sku,
        ...(data?.id && { id: data?.id }),
      });
      if (response.name) {
        setError(`${fieldPrefix}.name`, {
          message: 'Name already exists',
          type: 'manual',
          ref: `${fieldPrefix}.name`,
        });
        isUnique=false;
      }

      if (response.sku) {
        setError(`${fieldPrefix}.sku`, {
          message: 'SKU already exists',
          type: 'manual',
          ref: `${fieldPrefix}.sku`,
        });
        isUnique=false;
      }

      return isUnique;
    } catch (error) {
      console.error('Uniqueness check failed:', error);
      return isUnique;
    }
    //eslint-disable-next-line
  }, [formValues?.name, formValues?.sku, setError]);

  return { checkNameAndSkuUniqueness };
};

export default useNameSkuUniquenessCheck;
